import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updatePriceBook: null,
  loading: false,
  error: null,
};

const updatePriceBookSlice = createSlice({
  name: "updatePriceBook",
  initialState,
  reducers: {
    fetchUpdatePriceBookStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUpdatePriceBookSuccess: (state, action) => {
      state.loading = false;
      state.updatePriceBook = action.payload;
      state.error = null;
    },
    fetchUpdatePriceBookFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdatePriceBookStart,
  fetchUpdatePriceBookSuccess,
  fetchUpdatePriceBookFailure,
} = updatePriceBookSlice.actions;

export default updatePriceBookSlice.reducer;
